<template>
  <div class="oblig-card-container">
    <router-link
      class="oblig-link"
      :to="{
        path: '/obligatoriske-oppgaver/' + modul.slice(6, 7) + '-' + (id + 1),
        props: { text: obligs.text },
      }"
    >
      <div class="oblig-card">
        <p class="oblig-title">
          Obligatorisk oppgave {{ modul.slice(6, 7) }}-{{ id + 1 }}
        </p>
        <p class="oblig-small-text">{{ obligs.summary }}</p>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "BigPicture",
  props: {
    modul: String,
    obligs: Object,
    id: Number,
  },
  methods: {
    idToAddress(id) {
      return "/obligatoriske-oppgaver/" + id;
    },
  },
};
</script>

<style scoped>
.oblig-card {
  box-shadow: 1px 2px 5px 1px grey;
  padding: 4em;
  border-radius: var(--border-radius);
  margin: 15px 0;
  cursor: pointer;
  width: 200px;
  height: 200px;
}

.oblig-title {
  font-size: 1.4em;
  display: block;
  margin-bottom: 10px;
}
</style>